export default __webpack_public_path__ + "static/media/settings-back.7fab6ce1.svg";